export const SIMPLE_DATE_FORMAT = 'MM/DD/YYYY';
export const DATE_DISPLAY_FORMAT = 'MM/DD/YYYY hh:mm A';
export const DATE_DISPLAY_FORMAT_AT = 'MM/DD/YYYY @ hh:mm A';
export const DATE_HUMAN_FORMAT = 'MMM D, Y h:mm A';
export const DATE_HUMAN_FORMAT_NO_TIME = 'MMM D, Y';

export const DATE_UTC_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
